module.exports = __webpack_public_path__ + "static/outline-9547980b4d17e8c12e40494bd0bf078a.png";